import { render, staticRenderFns } from "./Statement-report-table.vue?vue&type=template&id=c4298ae4&scoped=true"
import script from "./Statement-report-table.vue?vue&type=script&lang=js"
export * from "./Statement-report-table.vue?vue&type=script&lang=js"
import style0 from "./Statement-report-table.vue?vue&type=style&index=0&id=c4298ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4298ae4",
  null
  
)

export default component.exports